import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import {tap, catchError, switchMap, filter, take} from 'rxjs/operators';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { LoginService } from '../demo/service/login.service';

@Injectable()
export class AuthHeadersInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private loginService: LoginService
    ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>>  {
    
    //TO DO: Provjeri može li ovo zamijeniti pojedinačna učitavanja tokena    
    const token = this.loginService.getJwtToken();
    if (token) {
        request = this.addToken(request, token);
    }
    //
    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {          
        //provjeri je li token expired ili je nešto drugo u pitanju        
        if (error.headers.get('token-expired') === "true") {          
          return this.handleRefreshToken(request, next);
        }
        else {          
          this.router.navigate(['login']);
        }                
      }
      else {
        return throwError(error);       
      }
      return this.handleRefreshToken(request,next);
    }));
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private handleRefreshToken(request: HttpRequest<any>, next: HttpHandler)  {    
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.loginService.refreshToken().pipe(
        switchMap((tokens: any) => {        
          this.isRefreshing = false;
          this.refreshTokenSubject.next(tokens.token);
          return next.handle(this.addToken(request, tokens.token));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          console.log(`Handling ${request.url} with new token:`)
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }
 }